<div class="container">
  <app-drawer-workorder-title
    title="{{ 'workorder.extra-time.title' | translate }}"
    [externalId]="workOrder.externalId"
    [clientName]="workOrder.clientName"
  ></app-drawer-workorder-title>
  <div class="time-container">
    <p>{{ "workorder.extra-time.description" | translate }}</p>
    <div class="extra-time">
      <span>{{ "workorder.extra-time.management" | translate }}</span>
      <input
        matInput
        type="number"
        [formControl]="managementTime"
        (change)="managementTimeChange()"
        onClick="this.select();"
      />
      <span class="minutes">min</span>
    </div>
    <div class="extra-time">
      <span>{{ "workorder.extra-time.transport" | translate }}</span>
      <input
        matInput
        type="number"
        [formControl]="transportTime"
        (change)="transportTimeChange()"
        onClick="this.select();"
      />
      <span class="minutes">min</span>
    </div>
  </div>
  <app-drawer-workorder-actions
    confirmButtonName="{{ 'workorder.extra-time.save' | translate }}"
    (clickConfirmButtonEvent)="saveWorkOrderExtraTime()"
    (clickCancelButtonEvent)="close()"
  ></app-drawer-workorder-actions>
</div>
